import script from "./ZButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZButton.vue?vue&type=script&setup=true&lang=ts"

import "./ZButton.vue?vue&type=style&index=0&id=b9e47796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e47796"]])

export default __exports__